"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BasketOfferTypes", {
  enumerable: true,
  get: function () {
    return _basketUpdated.BasketOfferTypes;
  }
});
exports.isConceptOfferHint = exports.isBasicOfferHint = exports.basketOfferTypeNames = void 0;
var _basketUpdated = require("@ori-events/basket-updated");
// TO-DO [2022-06-01]: export directly from event

const basketOfferTypeNames = exports.basketOfferTypeNames = {
  [_basketUpdated.BasketOfferTypes.BUY_WITH_DISCOUNT]: 'BUY_WITH_DISCOUNT',
  [_basketUpdated.BasketOfferTypes.GET_BENEFIT]: 'GET_BENEFIT',
  [_basketUpdated.BasketOfferTypes.CHOOSE_WITH_DISCOUNT]: 'CHOOSE_WITH_DISCOUNT',
  [_basketUpdated.BasketOfferTypes.CHOOSE_AND_GET]: 'CHOOSE_AND_GET',
  [_basketUpdated.BasketOfferTypes.CHOOSE_AND_CHOOSE]: 'CHOOSE_AND_CHOOSE'
};
const isBasicOfferHint = offerType => offerType === _basketUpdated.BasketOfferTypes.BUY_WITH_DISCOUNT || offerType === _basketUpdated.BasketOfferTypes.GET_BENEFIT;
exports.isBasicOfferHint = isBasicOfferHint;
const isConceptOfferHint = offerType => offerType === _basketUpdated.BasketOfferTypes.CHOOSE_AND_CHOOSE || offerType === _basketUpdated.BasketOfferTypes.CHOOSE_AND_GET || offerType === _basketUpdated.BasketOfferTypes.CHOOSE_WITH_DISCOUNT;
exports.isConceptOfferHint = isConceptOfferHint;